
const AlertTypes = {
      Alert_Danger : 'Danger Alert',
      Alert_Warning :'Warning Alert',
      Alert_Info : 'Information Alert',
      Alert_Success : 'Success Alert',
  }
  
  export default AlertTypes